import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';
import PropTypes from 'prop-types';

import YoutubeIframe from '@nubank/www-latam-commons/components/YoutubeIframe/YoutubeIframe';

export const ResponsiveImagesWrapper = styled.span`
  display: ${({ $hasDeviceOnMobile }) => ($hasDeviceOnMobile ? 'block' : 'none')};

  ${breakpointsMedia({
    md: css`
      display: block;
    `,
  })}

  img {
    z-index: 2;
    position: relative;
    pointer-events: none;
  }
`;

ResponsiveImagesWrapper.displayName = 'ResponsiveImagesWrapper';

ResponsiveImagesWrapper.propTypes = {
  $hasDeviceOnMobile: PropTypes.bool.isRequired,
};

const YoutubeIframeStyles = css`
  position: absolute;
  top: 45px;
  left: calc(50% - 128px);
  z-index: 1;
`;

export const StyledYoutubeIframe = styled(YoutubeIframe)`
  position: relative;

  ${({ $hasDeviceOnMobile }) => ($hasDeviceOnMobile && (YoutubeIframeStyles))}

  ${breakpointsMedia({
    md: YoutubeIframeStyles,
  })}
`;

StyledYoutubeIframe.displayName = 'StyledYoutubeIframe';

StyledYoutubeIframe.propTypes = {
  $hasDeviceOnMobile: PropTypes.bool.isRequired,
};

export const DeviceVideoWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 8;

  img {
    width: 278px;
    max-height: none;
  }
`;

DeviceVideoWrapper.displayName = 'DeviceVideoWrapper';

const FakeMobileBorderStyles = css`
  width: auto;
  border: 0;
  box-shadow: none;
`;

export const FakeMobileBorderOutter = styled.span`
  overflow: hidden;
  width: 254px;
  height: 455px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  border-radius: ${({ $mobileBorderRadius }) => `${$mobileBorderRadius}px`};

  ${({ $hasDeviceOnMobile }) => ($hasDeviceOnMobile && (FakeMobileBorderStyles))}

  ${breakpointsMedia({
    md: FakeMobileBorderStyles,
  })}
`;

FakeMobileBorderOutter.displayName = 'FakeMobileBorderOutter';

FakeMobileBorderOutter.propTypes = {
  $hasDeviceOnMobile: PropTypes.bool.isRequired,
  $mobileBorderRadius: PropTypes.string.isRequired,
};
